export default {
  workspaceGroups(state) {
    return state.workspaceGroups;
  },
  groupPermissions(state) {
    return state.groupPermissions;
  },
  groupPermissionsForSelect(state) {
    const groupedPermissions = {};
    state.groupPermissions.forEach((permission) => {
      const groupName = permission.permissionGroup;
      if (!groupedPermissions[groupName]) {
        groupedPermissions[groupName] = {
          text: groupName,
          children: [],
        };
      }
      groupedPermissions[groupName].children.push({
        id: String(permission.id),
        text: permission.name,
      });
    });
    return Object.values(groupedPermissions);
  },

  selectedGroupPermissionsForSelect(state) {
    return state.groupPermissions
      .filter((permission) => permission.selected)
      .map((permission) => permission.id);
  },
  workspaceSocialMediaAccountsForSelect(state) {
    return state.workspaceSocialMediaAccounts.map((socialMediaAccount) => ({
      id: socialMediaAccount.workspaceFeederId,
      text: socialMediaAccount.feederName,
    }));
  },
  selectedworkspaceSocialMediaAccountsForSelect(state) {
    return state.workspaceSocialMediaAccounts
      .filter((socialMediaAccount) => socialMediaAccount.isSelected)
      .map((socialMediaAccount) => socialMediaAccount.workspaceFeederId);
  },
};
